import { api } from '../../lib/api';

export const signIn = data => {
  const transformedData = {
    email: data.email,
    password: data.password,
    remember_me: data.rememberMe,
  };
  return api({
    method: 'post',
    url: '/api/sessions/',
    data: transformedData,
  });
};
